// extracted by mini-css-extract-plugin
export var scrollArea = "_nx-0";